var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.mobile)?_c('gnav-sp'):_c('gnav-pc'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.name)+"さん、こんにちは。")]),_vm._v(" "),_c('hello-world',{attrs:{"myName":_vm.name},on:{"nameReset":function($event){_vm.name = $event}}}),_vm._v(" "),_c('form-content'),_vm._v(" "),_c('my-counter'),_vm._v(" "),_c('p',[_vm._v("Counter is : "+_vm._s(_vm.counter))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2874caf4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 